import pako from 'pako';

export function decompressData(compressedData: string): any {
    try {
        // Decode Base64
        const binaryString = atob(compressedData);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        
        // Decompress GZIP
        const decompressed = pako.ungzip(bytes, { to: 'string' });
        
        // Parse JSON
        return JSON.parse(decompressed);
    } catch (error) {
        console.error('Failed to decompress data:', error);
        throw error;
    }
}